module.exports = __webpack_public_path__ + "static/media/RecomendaCaldasNovas.46feca64.jpg";